/** UI languages and their endonyms; no i18next setup, so importing this has no side effects. */
export const supportedLanguages = ['fi', 'sv', 'en'] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

export const languageNames: Record<SupportedLanguage, string> = {
  fi: 'Suomi',
  sv: 'Svenska',
  en: 'English',
};

/**
 * Languages still being translated (#3781). They are valid content languages
 * (quotes, a person's preferred language) but are kept out of the UI language
 * menu, and the locale parity test only requires their existing keys to be
 * correct rather than every key to exist. Removing a language from this list
 * is the switch that ships it: the menu shows it and the parity test turns strict.
 */
export const pendingUiLanguages: readonly SupportedLanguage[] = ['sv'];

/** Languages the staff can pick as their UI language. */
export const uiLanguages: readonly SupportedLanguage[] = supportedLanguages.filter(
  (lng) => !pendingUiLanguages.includes(lng),
);
